export default __webpack_public_path__ + "static/media/chime1.e65310af.mp3";